module.exports = __webpack_public_path__ + "img/img4.2ea1db6d.png";